import {
  GET_CASH_DISTRIBUTION_REPORT,
  GET_CASH_DISTRIBUTION_REPORT_ERROR,
  GET_CASH_DISTRIBUTION_REPORT_SUCCESS,
  GET_EXCEL_ORDER,
  GET_EXCEL_ORDER_ERROR,
  GET_EXCEL_ORDER_SUCCESS,
  GET_ORDER_INVOICE_LIST,
  GET_ORDER_INVOICE_LIST_ERROR,
  GET_ORDER_INVOICE_LIST_SUCCESS,
  GET_ORDER_SUMMARY_REPORT,
  GET_ORDER_SUMMARY_REPORT_ERROR,
  GET_ORDER_SUMMARY_REPORT_SUCCESS,
  GET_PURCHASE_ORDER_REPORT,
  GET_PURCHASE_ORDER_REPORT_ERROR,
  GET_PURCHASE_ORDER_REPORT_SUCCESS,
  GET_STYLE_WISE_ORDER_SUMMARY_REPORT,
  GET_STYLE_WISE_ORDER_SUMMARY_REPORT_ERROR,
  GET_STYLE_WISE_ORDER_SUMMARY_REPORT_SUCCESS,
} from "../actions/reportAction";

const initialState = {
  orderReportData: [], //THIS IS UESED FOR TO HOLD ARRAY DATA
  orderInvoiceListData: [],
  POReportListData: [],
  orderSummaryReportData: [],
  styleWiseOrderSummaryReportData: [],
  cashDistributionReportData: [],
  data: {}, // THIS IS USED FOR TO HOLD SAVE DATA
  loading: false,
  loaded: false,
  saving: false,
  saved: false,
  updating: false,
  updated: false,
  deleting: false,
  deleted: false,
  error: null,
  orderInvoiceLoading: false,
  orderInvoiceLoaded: false,
  orderInvoiceError: null,
  orderSummaryReportLoading: false,
  orderSummaryReportLoaded: false,
  orderSummaryReportError: null,
  styleWiseOrderSummaryReportLoading: false,
  styleWiseOrderSummaryReportLoaded: false,
  styleWiseOrderSummaryReportError: null,
  cashDistributionReportLoading: false,
  cashDistributionReportLoaded: false,
  cashDistributionReportError: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_EXCEL_ORDER:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };

    case GET_EXCEL_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        orderReportData: action.payload.success,
      };

    case GET_EXCEL_ORDER_ERROR:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.payload.error,
        orderReportData: [],
      };

    case GET_ORDER_INVOICE_LIST:
      return {
        ...state,
        orderInvoiceLoading: true,
        orderInvoiceLoaded: false,
        orderInvoiceError: null,
      };

    case GET_ORDER_INVOICE_LIST_SUCCESS:
      return {
        ...state,
        orderInvoiceLoading: false,
        orderInvoiceLoaded: true,
        orderInvoiceListData: action.payload.success,
      };

    case GET_ORDER_INVOICE_LIST_ERROR:
      return {
        ...state,
        orderInvoiceLoading: false,
        orderInvoiceLoaded: false,
        orderInvoiceError: action.payload.error,
        orderInvoiceListData: [],
      };

    case GET_PURCHASE_ORDER_REPORT:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };

    case GET_PURCHASE_ORDER_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        POReportListData: action.payload.success,
      };

    case GET_PURCHASE_ORDER_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.payload.error,
        POReportListData: [],
      };

    case GET_ORDER_SUMMARY_REPORT:
      return {
        ...state,
        orderSummaryReportLoading: true,
        orderSummaryReportLoaded: false,
        orderSummaryReportError: null,
      };

    case GET_ORDER_SUMMARY_REPORT_SUCCESS:
      return {
        ...state,
        orderSummaryReportLoading: false,
        orderSummaryReportLoaded: true,
        orderSummaryReportData: action.payload.success,
      };

    case GET_ORDER_SUMMARY_REPORT_ERROR:
      return {
        ...state,
        orderSummaryReportLoading: false,
        orderSummaryReportLoaded: false,
        orderSummaryReportError: action.payload.error,
        orderSummaryReportData: [],
      };

    case GET_STYLE_WISE_ORDER_SUMMARY_REPORT:
      return {
        ...state,
        styleWiseOrderSummaryReportLoading: true,
        styleWiseOrderSummaryReportLoaded: false,
        styleWiseOrderSummaryReportError: null,
      };

    case GET_STYLE_WISE_ORDER_SUMMARY_REPORT_SUCCESS:
      return {
        ...state,
        styleWiseOrderSummaryReportLoading: false,
        styleWiseOrderSummaryReportLoaded: true,
        styleWiseOrderSummaryReportData: action.payload.success,
      };

    case GET_STYLE_WISE_ORDER_SUMMARY_REPORT_ERROR:
      return {
        ...state,
        styleWiseOrderSummaryReportLoading: false,
        styleWiseOrderSummaryReportLoaded: false,
        styleWiseOrderSummaryReportError: action.payload.error,
        styleWiseOrderSummaryReportData: [],
      };

    case GET_CASH_DISTRIBUTION_REPORT:
      return {
        ...state,
        cashDistributionReportLoading: true,
        cashDistributionReportLoaded: false,
        cashDistributionReportError: null,
      };

    case GET_CASH_DISTRIBUTION_REPORT_SUCCESS:
      return {
        ...state,
        cashDistributionReportLoading: false,
        cashDistributionReportLoaded: true,
        cashDistributionReportData: action.payload.success,
      };

    case GET_CASH_DISTRIBUTION_REPORT_ERROR:
      return {
        ...state,
        cashDistributionReportLoading: false,
        cashDistributionReportLoaded: false,
        cashDistributionReportError: action.payload.error,
        cashDistributionReportData: [],
      };

    default:
      return state;
  }
}
